module.exports = __webpack_public_path__ + "img/hr-stone-furnace-fire.41c3d5f3.png";